import { buildSseWireText } from './sseWireFormat'

// 正常応答（テキスト + ツール実行 + アーティファクト）のSSEフィクスチャ。
// storybook/stories/AiChatWorkspace.stories.tsx の「SSEから描画」storyが元々インラインで
// 持っていたイベント列をここへ移設したもの（内容は変えていない）
export const normalResponseSse: string = buildSseWireText([
  { type: 'text_delta', text: '集計します。' },
  { type: 'tool_pending', toolUseId: 'tool-1', name: 'execute_graphql' },
  { type: 'tool_start', toolUseId: 'tool-1', name: 'execute_graphql', summary: '発注データを集計しています' },
  { type: 'tool_end', toolUseId: 'tool-1', name: 'execute_graphql', isError: false },
  { type: 'text_delta', text: '結果は以下のとおりです。' },
  { type: 'tool_pending', toolUseId: 'tool-2', name: 'render_html_report' },
  // render_html_report も execute_graphql と同じく tool_start → tool_end を伴う（実際の
  // バックエンド送出系列。この tool_end が欠けていたことが「No tool invocation found」エラーの
  // 原因だったため、回帰防止のためフィクスチャにも必ず含める）
  { type: 'tool_start', toolUseId: 'tool-2', name: 'render_html_report', summary: 'メーカー別発注件数' },
  { type: 'artifact', title: 'メーカー別発注件数', html: '<h1>メーカー別発注件数</h1>' },
  { type: 'tool_end', toolUseId: 'tool-2', name: 'render_html_report', isError: false },
  {
    type: 'done',
    usage: { inputTokens: 1, outputTokens: 1 },
    costUsd: 0,
    isError: false,
    durationMs: 1,
    durationApiMs: 1,
    numTurns: 1,
  },
])
